import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'StoreModel';
import { ApplicationDefinition } from 'redux/types/account';
import PreviewApplication from '../../components/application/preview';
import styled from 'styled-components';
import { getLiteralsAsync } from 'redux/actions/account';
import { Languages } from 'redux/types/enums';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {
  getLiterals: getLiteralsAsync.request,
};

type dispatchType = typeof mapDispatchToProps;

interface Props extends ReturnType<typeof mapStateToProps>, dispatchType {
  applicationDefinition: ApplicationDefinition;
}

const NewApplicationPage: React.FC<Props> = props => {
  const { applicationDefinition, getLiterals } = props;

  useEffect(() => {
    getLiterals({ language: applicationDefinition?.language as Languages });
  }, [applicationDefinition?.language]);

  return (
    <React.Fragment>
      <Container>
        <PreviewApplication applicationDefinition={applicationDefinition} />
      </Container>
    </React.Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewApplicationPage);
